import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
} from "@chakra-ui/modal";
import { PortalManager } from "@chakra-ui/portal";
import { t } from "i18next";
import GenericButton from "widgets/controls/buttons/generic";

const GenericDialog = (props: {
  children: React.ReactNode;
  isOpen: boolean;
  title: string;
  onClose?: () => void;
  onSave?: () => void;
  onOk?: () => void;
  onDelete?: () => void;
  onExit?: () => void;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
}) => {
  const {
    isOpen,
    onClose,
    onSave,
    onOk,
    onDelete,
    title,
    children,
    onExit,
    size,
  } = props;

  const sizeMap: Record<
    "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl",
    string
  > = {
    xs: "min-w-[200px]",
    sm: "min-w-[300px]",
    md: "min-w-[400px]",
    lg: "min-w-[600px]",
    xl: "min-w-[800px]",
    "2xl": "min-w-[1000px]",
    "3xl": "min-w-[1200px]",
  };

  const sizeClass = size ? sizeMap[size] : "min-w-[400px]";

  return (
    <>
      <PortalManager zIndex={2000}>
        <Modal isCentered={true} isOpen={isOpen} onClose={onExit}>
          <ModalOverlay className="bg-[#000] !opacity-30" />
          <ModalContent
            className={`top-[6vh] mx-2 rounded-md bg-white p-1 sm:top-[12vh] sm:!m-auto sm:!max-w-[60%] md:!max-w-[50%] lg:!max-w-[45%] xl:!max-w-[35%] 2xl:!max-w-[25%] ${sizeClass}`}
          >
            <ModalHeader className="heading-md px-4 py-4 text-primary">
              {title}
              <ModalCloseButton className="absolute right-5 top-5 z-10 text-txt-sm text-secondary" />
            </ModalHeader>

            <ModalBody className="px-4 py-3 text-txt-md text-secondary">
              {children}
            </ModalBody>
            {(onClose || onSave || onOk || onDelete) && (
              <ModalFooter className="gap-2 px-4 py-4">
                {onClose && (
                  <GenericButton
                    onClick={onClose}
                    text={t("button.action.close")}
                    size="md"
                    variant="ghost"
                    color="secondary"
                  />
                )}
                {onSave && (
                  <GenericButton
                    onClick={onSave}
                    text={t("button.action.save")}
                    size="md"
                  />
                )}
                {onOk && (
                  <GenericButton
                    onClick={onOk}
                    text={t("button.action.ok")}
                    size="md"
                  />
                )}
                {onDelete && (
                  <GenericButton
                    onClick={onDelete}
                    text={t("button.action.delete")}
                    size="md"
                  />
                )}
              </ModalFooter>
            )}
          </ModalContent>
        </Modal>
      </PortalManager>
    </>
  );
};

export default GenericDialog;
